import { render, staticRenderFns } from "./TrUiTitle.vue?vue&type=template&id=339217a2&scoped=true&"
import script from "./TrUiTitle.vue?vue&type=script&lang=js&"
export * from "./TrUiTitle.vue?vue&type=script&lang=js&"
import style0 from "./TrUiTitle.vue?vue&type=style&index=0&id=339217a2&lang=scss&scoped=true&"
import style1 from "./TrUiTitle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339217a2",
  null
  
)

export default component.exports